
const TaggingHelp = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Tagging Compliance
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          The Tagging page helps you enforce cloud resource tagging policies across your AWS infrastructure.
          Monitor compliance, identify untagged resources, and ensure consistent cost allocation and
          governance through proper resource tagging.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Tagging Policies
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Define and enforce tagging standards across your organization.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Required Tags:</strong> Specify which tags are mandatory for all resources</li>
          <li><strong>Allowed Values:</strong> Define permitted values for specific tag keys</li>
          <li><strong>Tag Inheritance:</strong> Automatically propagate tags from parent resources</li>
          <li><strong>Policy Enforcement:</strong> Prevent resource creation without required tags</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Compliance Dashboard
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Monitor overall tagging compliance across your AWS environments.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Compliance Score:</strong> Percentage of resources meeting tagging policies</li>
          <li><strong>Policy Status:</strong> Active policies and their enforcement rules</li>
          <li><strong>Violation Count:</strong> Number of non-compliant resources</li>
          <li><strong>Trend Analysis:</strong> Compliance improvements or degradations over time</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Cost Allocation Tags
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Track costs by project, team, or department using standardized tags.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Cost Breakdown:</strong> View spending grouped by tag values</li>
          <li><strong>Service Distribution:</strong> See which services contribute to costs per tag</li>
          <li><strong>Unallocated Costs:</strong> Identify spending from untagged resources</li>
          <li><strong>Tag Coverage:</strong> Percentage of costs attributed to tagged resources</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Untagged Resources
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Identify and remediate resources missing required tags.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Resource List:</strong> All resources without required tags</li>
          <li><strong>Service Types:</strong> Filter by AWS service (EC2, S3, RDS, etc.)</li>
          <li><strong>Account Filter:</strong> View untagged resources per AWS account</li>
          <li><strong>Bulk Tagging:</strong> Apply tags to multiple resources at once</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Tag Standards
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Common tagging patterns implemented in CloudOps.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Environment:</strong> Development, Staging, Production</li>
          <li><strong>Project:</strong> Project name or code for cost allocation</li>
          <li><strong>Owner:</strong> Team or individual responsible for the resource</li>
          <li><strong>CostCenter:</strong> Department or business unit for chargeback</li>
          <li><strong>Compliance:</strong> Regulatory or security classification</li>
          <li><strong>Lifecycle:</strong> Automation tags for resource management</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Remediation Actions
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Tools to fix tagging compliance issues across your infrastructure.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Manual Tagging:</strong> Add or update tags directly from the interface</li>
          <li><strong>Automated Rules:</strong> Set up automatic tagging based on resource attributes</li>
          <li><strong>Tag Templates:</strong> Pre-defined tag sets for common resource types</li>
          <li><strong>Compliance Reports:</strong> Export non-compliant resources for remediation</li>
        </ul>
      </div>

    </>
  );
};

export default TaggingHelp;
